/**
 * Shared number and time formatters, one per locale and precision. `toLocaleString` builds a new
 * Intl formatter on every call, and the page renders while the runner timestamps echoes on the same
 * thread: render time shows up as ping and jitter.
 */
const numbers = new Map<string, Intl.NumberFormat>();
const times = new Map<string, Intl.DateTimeFormat>();

export function numberFormat(locale: string, maximumFractionDigits = 0): Intl.NumberFormat {
    const key = `${locale}|${maximumFractionDigits}`;
    let f = numbers.get(key);
    if (!f) {
        f = new Intl.NumberFormat(locale, { maximumFractionDigits });
        numbers.set(key, f);
    }
    return f;
}

export function timeFormat(locale: string): Intl.DateTimeFormat {
    let f = times.get(locale);
    if (!f) {
        f = new Intl.DateTimeFormat(locale, { timeStyle: 'medium' });
        times.set(locale, f);
    }
    return f;
}
